export const load = () => ({
	title: 'Window Measurement Instructions',
	showTitle: true,
});
